import * as React from "react";
import { Row } from "reactstrap";

import Assets from "./DashboardCards/Assets";
import Requests from "./DashboardCards/Requests";
import WorkOrders from "./DashboardCards/WorkOrders";

export default class DashboardSummaries extends React.Component<{
  companyId: string;
}> {
  render() {
    const { companyId } = this.props;
    return (
      <Row>
        <WorkOrders companyId={companyId} />
        <Requests companyId={companyId} />
        <Assets companyId={companyId} />
      </Row>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Containers/Dashboard/DashboardSummaries.tsx